import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllStaff = createAsyncThunk(
    'staff/getAllStaff',
    async ({ skip, limit, search, roles }, { rejectWithValue }) => {
        try {
            const params = {};

            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (roles && roles.length > 0) params.role_name = roles.join(',');

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/users/staff`, config);
            console.log(response.data);
            return response.data;

        } catch (error) {
            console.log(error);
            if (error.message === 'Network Error') {
                return rejectWithValue({
                    response: {
                        data: {
                            message: 'Network Error',
                            status: error.code,
                        }
                    }
                });
            } else {
                return rejectWithValue({
                    message: 'Error',
                    status: error.code,
                })
            }
        }
    }
);

export const editStaff = createAsyncThunk(
    'staff/editStaff',
    async (updatedData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/users/update-user-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: 'Network Error',
                    status: err.code,
                    success: false,
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
)

export const createStaff = createAsyncThunk(
    'staff/createStaff',
    async (newData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(newData);
            const response = await axios.post(`${PUBLIC_BASE_URL}/users/create-staff`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: 'Network Error',
                    status: err.code,
                    success: false,
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
)